import './styles.scss'

import { ApiMutualFundAssetRead, ApiSegregatedPortfolioAssetRead } from 'api/rtk-api'

import { LabelValueRow } from '../..'

const getValue = ({
  asset,
  strategyName
}: {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  strategyName: string
}) => (asset.disallowedStrategies.includes(strategyName) ? 'Unavailable' : 'Available')

export const Strategies = ({
  asset
}: {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
}) => (
  <>
    <LabelValueRow
      label="Delta One"
      showTopBorder={false}
      value={getValue({ asset, strategyName: 'Delta1' })}
    />
    <LabelValueRow
      label="Constant proportion leverage"
      value={getValue({ asset, strategyName: 'ConstantProportionLeverage' })}
    />
    <LabelValueRow label="Risk managed" value={getValue({ asset, strategyName: 'RiskManaged' })} />
    <LabelValueRow
      label="Volatility control leverage"
      value={getValue({ asset, strategyName: 'VolatilityControlLeverage' })}
    />
    <LabelValueRow
      label="Continuous protection"
      value={getValue({ asset, strategyName: 'ContinuousProtection' })}
    />
    <LabelValueRow
      label="Term protection"
      value={getValue({ asset, strategyName: 'TermProtection' })}
    />
  </>
)
